import { FileUpload as FileUploadIcon, Add as AddIcon } from "@mui/icons-material";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export interface ImportMethodSelectionProps {
  importMethod: "csv" | "manual" | "";
  onSelectMethod: (method: "csv" | "manual") => void;
}

export const ImportMethodSelection: React.FC<ImportMethodSelectionProps> = ({
  importMethod,
  onSelectMethod,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card
          onClick={() => onSelectMethod("csv")}
          sx={{
            height: "100%",
            cursor: "pointer",
            border: importMethod === "csv" ? "2px solid #5e72e4" : "1px solid #e9ecef",
            transition: "all 0.2s",
            "&:hover": {
              boxShadow: "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)",
            },
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
            }}
          >
            <FileUploadIcon sx={{ fontSize: 60, color: "#5e72e4", mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              {t("leads.importFromCSV")}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {t("leads.uploadCSV")}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card
          onClick={() => onSelectMethod("manual")}
          sx={{
            height: "100%",
            cursor: "pointer",
            border: importMethod === "manual" ? "2px solid #5e72e4" : "1px solid #e9ecef",
            transition: "all 0.2s",
            "&:hover": {
              boxShadow: "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)",
            },
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
            }}
          >
            <AddIcon sx={{ fontSize: 60, color: "#5e72e4", mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              {t("leads.manualEntry")}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {t("leads.manualSelect")}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
